export const categoriasInitialState = {
  categorias: [],
  novaCategoria: [],
  categoriaRemovida: [],
  categoria: [],
  categoriaEditada: [],
};
